<div class="container-fluid" [ngClass]="{'p-0': mobileMode, 'h-100': mobileMode}" style="position: relative"
  [style.background-color]="clozeTestStyleModel.siteBackground">
  <div class="d-flex justify-content-center" [ngClass]="{'h-100': mobileMode}">
    <div class="card" [ngClass]="{'container-fluid': mobileMode, 'p-0': mobileMode}" style="min-height: 570px;"
      [style.background-color]="clozeTestStyleModel.exerciseBackground"
      [ngStyle]="{'border': mobileMode ? '0px' : '1px solid ' + clozeTestStyleModel.frameColor, 'border-radius': mobileMode? '0px' : '0.25rem', 'width': mobileMode? '' : '720px'}">
      <!-- mobile exercise indicator start -->
      <ng-container *ngIf="mobileMode">
        <gast-cloze-test-exercise-indicator [totalExercise]="totalExercise" [cTestLogo]="cTestLogo"
          [displayLogo]="clozeTestStyleModel.displayLogo" [currentExcerciseNumber]="currentExcerciseNumber">
        </gast-cloze-test-exercise-indicator>
      </ng-container>
      <!-- mobile exercise indicator end -->
      <div class="card-body" [ngClass]="{'card-mobile': mobileMode }" [style.font-family]="clozeTestStyleModel.font"
        [style.font-size]="this.clozeTestStyleModel.fontSize" style="overflow-y: auto;">
        <img *ngIf="clozeTestStyleModel.displayLogo && !mobileMode" class="floating-logo" [src]="cTestLogo">
        <h5 class="card-title text-center font-weight-bold" [innerHTML]="title"></h5>
        <div [style.line-height]="lineHeight" style="padding-top: 10px;">
          <ng-container *ngFor="let input of inputs; let i = index">
            <gast-cloze-test-exercise-input [mobileMode]="mobileMode" [nr]="input.id" [text]="input.text"
              [isLast]="i === inputs.length - 1" [lastWord]="input.lastWord" [answer]="input.answer">
            </gast-cloze-test-exercise-input>
          </ng-container>
        </div>
        <div class="text-center" style="padding-top: 10px;">
          <div class="row justify-content-around">
            <div class="col-2" style="padding-top: 6px;">
              <div *ngIf="!mobileMode">
                <p>
                  {{ 'GAST-ONSET-NG.EXERCISE.TEXT_FROM_TO' | translate: { 
                    currentExcerciseNumber : currentExcerciseNumber, 
                    lastExerciseNumber: lastExerciseNumber 
                  } }}<br>
                </p>
              </div>
            </div>
            <div *ngIf="inputs && inputs.length > 0" class="col-4" style="padding-top: 4px;">
              <input type="checkbox" style="vertical-align: middle;" id="finishCheckbox" name="finishCheckbox"
                [checked]="readyCheckbox" (change)="readyCheckbox = !readyCheckbox">
              <label class="font-weight-bold" for="finishCheckbox" style="font-size: smaller;padding-left: 6px;">
                {{ 'GAST-ONSET-NG.EXERCISE.DONE' | translate }}</label>
            </div>
            <div class="col-4">
              <ng-container *ngIf="!isLastExercise">
                <button class="btn" style="font-size: smaller;" (click)="onNextExercise()" [hidden]="!readyCheckbox"
                  [disabled]="!readyCheckbox" [style.background-color]="cTestButtonColor">
                  {{ 'GAST-ONSET-NG.EXERCISE.CONTINUE' | translate }}
                </button>
              </ng-container>
              <ng-container *ngIf="isLastExercise">
                <button class="btn" style="font-size: smaller;" (click)="onTestEnd()" [hidden]="!readyCheckbox"
                  [disabled]="!readyCheckbox" [style.background-color]="cTestButtonColor">
                  {{ 'GAST-ONSET-NG.EXERCISE.END_TEST' | translate }}
                </button>
              </ng-container>
            </div>
            <div class="col-2">
            </div>
            <div *ngIf="!mobileMode" style="margin-top: 8px;">
              <ng-container *ngIf="timeLeft <= limitWhenToShowTime">
                {{ 'GAST-ONSET-NG.EXERCISE.TIME_REMAINING' | translate }} {{timeLeft}}
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <!-- Mobile keyboard -->
      <div *ngIf="mobileMode" style="margin-top: 8px;position: absolute;bottom:0;"
        class="container-fluid mobile-keyboard">
        <div class="d-flex justify-content-center keyboard-row">
          <button #buttonVar class="mobile-keyboard-button" (touchstart)="assignCharacter('q', $event)"
            (touchend)="onTouchend($event)">q</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('w', $event)"
            (touchend)="onTouchend($event)">w</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('e', $event)"
            (touchend)="onTouchend($event)">e</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('r', $event)"
            (touchend)="onTouchend($event)">r</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('t', $event)"
            (touchend)="onTouchend($event)">t</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('z', $event)"
            (touchend)="onTouchend($event)">z</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('u', $event)"
            (touchend)="onTouchend($event)">u</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('i', $event)"
            (touchend)="onTouchend($event)">i</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('o', $event)"
            (touchend)="onTouchend($event)">o</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('p', $event)"
            (touchend)="onTouchend($event)">p</button>
          <button class="mobile-keyboard-button mr-0" (touchstart)="assignCharacter('ü', $event)"
            (touchend)="onTouchend($event)">ü</button>
        </div>
        <div class="d-flex justify-content-center keyboard-row" style="margin-top: 4px;">
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('a', $event)"
            (touchend)="onTouchend($event)">a</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('s', $event)"
            (touchend)="onTouchend($event)">s</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('d', $event)"
            (touchend)="onTouchend($event)">d</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('f', $event)"
            (touchend)="onTouchend($event)">f</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('g', $event)"
            (touchend)="onTouchend($event)">g</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('h', $event)"
            (touchend)="onTouchend($event)">h</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('j', $event)"
            (touchend)="onTouchend($event)">j</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('k', $event)"
            (touchend)="onTouchend($event)">k</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('l', $event)"
            (touchend)="onTouchend($event)">l</button>
          <button class="mobile-keyboard-button" (touchstart)="assignCharacter('ö', $event)"
            (touchend)="onTouchend($event)">ö</button>
          <button class="mobile-keyboard-button mr-0" (touchstart)="assignCharacter('ä', $event)"
            (touchend)="onTouchend($event)">ä</button>
        </div>
        <div class="d-flex justify-content-center keyboard-row" style="margin-top: 4px;">
          <button [ngStyle]="{'max-width.px': buttonVar.offsetWidth }" class="mobile-keyboard-button"
            (touchstart)="assignCharacter('y', $event)" (touchend)="onTouchend($event)">y</button>
          <button [ngStyle]="{'max-width.px': buttonVar.offsetWidth }" class="mobile-keyboard-button"
            (touchstart)="assignCharacter('x', $event)" (touchend)="onTouchend($event)">x</button>
          <button [ngStyle]="{'max-width.px': buttonVar.offsetWidth }" class="mobile-keyboard-button"
            (touchstart)="assignCharacter('c', $event)" (touchend)="onTouchend($event)">c</button>
          <button [ngStyle]="{'max-width.px': buttonVar.offsetWidth }" class="mobile-keyboard-button"
            (touchstart)="assignCharacter('v', $event)" (touchend)="onTouchend($event)">v</button>
          <button [ngStyle]="{'max-width.px': buttonVar.offsetWidth }" class="mobile-keyboard-button"
            (touchstart)="assignCharacter('b', $event)" (touchend)="onTouchend($event)">b</button>
          <button [ngStyle]="{'max-width.px': buttonVar.offsetWidth }" class="mobile-keyboard-button"
            (touchstart)="assignCharacter('n', $event)" (touchend)="onTouchend($event)">n</button>
          <button [ngStyle]="{'max-width.px': buttonVar.offsetWidth }" class="mobile-keyboard-button"
            (touchstart)="assignCharacter('m', $event)" (touchend)="onTouchend($event)">m</button>
          <button [ngStyle]="{'max-width.px': buttonVar.offsetWidth }" class="mobile-keyboard-button"
            (touchstart)="assignCharacter('ß', $event)" (touchend)="onTouchend($event)">ß</button>
          <button [ngStyle]="{'max-width.px': buttonVar.offsetWidth * 2 }"
            class="mobile-keyboard-button remove-button mr-0" (touchstart)="removeLastCharacter($event)"
            (touchend)="onTouchend($event)"><i class="fas fa-backspace" style="pointer-events: none;"></i></button>
        </div>
        <div class="d-flex justify-content-center keyboard-row" style="margin-top: 4px;">
          <div class="col-4 p-0" style="text-align: center;display: table;height: 34px;margin-right: 4px;
          margin-left: 4px;" [ngClass]="{'info-box': showTimer() }">
            <span *ngIf="showTimer()" style="vertical-align: middle;display: table-cell;">
              {{ 'GAST-ONSET-NG.MOBILE.TIME_REMAINING' | translate: {timeLeft: timeLeft} }}</span>
          </div>
          <div class="col-4" style="padding-left: 0px;padding-right:0px;">
            <button class="mobile-keyboard-button" style="width: 33%;background-color:#50b4ae;"
              (touchstart)="goToPreviousInput($event)"><i class="fas fa-caret-left"></i></button>
            <button class="mobile-keyboard-button" style="width: 33%;background-color:#50b4ae;"
              (touchstart)="goToNextInput($event)"><i class="fas fa-caret-right"></i></button>
          </div>
          <div class="col-4">
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- special character for non german keyboard -->
  <div *ngIf="!mobileMode" class="d-flex justify-content-center" style="padding-top: 10px;">
    <div class="alert text-center" style="width: 720px; line-height: 30px; padding: 0px 15px;"
      [style.background-color]="clozeTestStyleModel.specialCharacterListColor"
      [style.border]="'1px solid ' + clozeTestStyleModel.frameColor" [style.font-family]="clozeTestStyleModel.font"
      role="alert">
      <span
        [style.color]="clozeTestStyleModel.specialChcaracterTextColor">{{ 'GAST-ONSET-NG.EXERCISE.SPECIAL_CHAR_INFO' | translate }}</span>
      <span class="badge badge-secondary" (click)="assignCharacter('ä', $event)" [style.font-size]="'15px'"
        style="margin-right: 5px; cursor: pointer;">ä</span>
      <span class="badge badge-secondary" (click)="assignCharacter('ö', $event)" [style.font-size]="'15px'"
        style="margin-right: 5px; cursor: pointer;">ö</span>
      <span class="badge badge-secondary" (click)="assignCharacter('ü', $event)" [style.font-size]="'15px'"
        style="margin-right: 5px; cursor: pointer;">ü</span>
      <span class="badge badge-secondary" (click)="assignCharacter('ß', $event)" [style.font-size]="'15px'"
        style="margin-right: 5px; cursor: pointer;">ß</span>
    </div>
  </div>
</div>
